import { apiSlice } from "./index";
import { Link as RLink } from "react-router-dom";
import Link from "@mui/material/Link";
import {
    upsertContact,
    upsertContacts,
    Contact,
    ContactEditRequest,
    ContactResponse,
} from "../features/contact/contactSlice";
import { Filter } from "../features/filter/filterSlice";

function buildIdsQuery(ids: string[]): string {
    const params = new URLSearchParams();
    ids.forEach((id) => params.append("ids", id));
    return "?" + params.toString();
}

const contactApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getContact: builder.query({
            //query: (id) => `ticket/items-view/${id}?planned_start_after=2024-08-15T12:00:00Z`,
            query: (id) => `contact/get/${id}`,
            async onQueryStarted(args, { dispatch, queryFulfilled }) {
                console.log("ticket query started");
                try {
                    const { data } = await queryFulfilled;
                    console.log("Data Received", data);
                    dispatch(upsertContact(data.contact));
                    dispatch(upsertContacts(data.contacts));
                } catch (err) {
                    console.log("ho no, error in ticket query");
                }
            },
        }),
        searchContacts: builder.query<ContactResponse, Filter>({
            query: (f: Filter) => `contact/search/?text=${f.search_text}`,
            async onQueryStarted(args, { dispatch, queryFulfilled }) {
                console.log("ticket query started");
                try {
                    const { data } = await queryFulfilled;
                    console.log("Data Received", data);
                    dispatch(upsertContacts(data.contacts));
                } catch (err) {
                    console.log("ho no, error in ticket query");
                }
            },
        }),
        searchContactsById: builder.query<
            ContactResponse,
            { ids: { [key: string]: Contact } }
        >({
            query: ({ ids }) => {
                const str = buildIdsQuery(Object.keys(ids));
                return `contact/search-bi/` + str;
                //return `contact/search-bi/?ids=${"1"}&ids=4`;
            },
            async onQueryStarted(args, { dispatch, queryFulfilled }) {
                console.log("ticket query started");
                try {
                    const { data } = await queryFulfilled;
                    console.log("Data Received", data);
                    dispatch(upsertContacts(data.contacts));
                } catch (err) {
                    console.log("ho no, error in ticket query");
                }
            },
        }),
        edit: builder.mutation<ContactResponse, ContactEditRequest>({
            query: (body) => {
                const idStr = body.id ? "/" + body.id : "";
                return {
                    url: "/ticket/edit" + idStr,
                    method: "POST",
                    body,
                };
            },
            invalidatesTags: [],
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    if (data.contact) {
                        dispatch(upsertContact(data.contact));
                    }
                } catch (err) {
                    console.log("202411301427: edit ticket api error", err);
                }
            },
        }),
        /*
        copy: builder.mutation<TicketResponse, string>({
            query: (id) => {
                const idStr = "/" + id;
                return {
                    url: "/ticket/copy" + idStr,
                    method: "POST",
                };
            },
            invalidatesTags: [],
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    if (data.ticket) {
                        dispatch(upsertTicket(data.ticket));
                    }
                } catch (err) {
                    console.log("202501031130: copy ticket api error", err);
                }
            },
        }),
        // */
    }),
});

export const {
    useGetContactQuery,
    useSearchContactsQuery,
    useSearchContactsByIdQuery,
    useEditMutation,
} = contactApi;
